export const COLORS = {
    BADGE: {
        1: 'success',
        2: 'error',
        3: 'orange',
        4: 'orange',
        5: 'orange',
        6: 'purple'
    },
    STATUS: {
        1: 'action-accent',
        2: 'success',
        3: 'orange',
        4: 'purple',
        5: 'delivery',
        6: 'secondary',
        7: 'disabled',
        8: 'action-accent',
        9: 'success',
        10: 'orange',
        11: 'secondary',
        12: 'disabled',
        13: 'action-accent',
        14: 'success',
        15: 'delivery',
        16: 'purple',
        17: 'secondary',
        18: 'disabled'
    },
    NAME: {
        SUCCESS: 'var(--success)',
        BACKGROUND: 'var(--background)',
        SECOND_BACKGROUND:'var(--second-bacground)',
        MAIN_BACKGROUND: 'var(--main-background)',
        ACCENT: 'var(--accent)',
        MAIN: 'var(--main)',
        SECONDARY: 'var(--secondary)',
        DISABLED: 'var(--disabled)',
        ACTION_ACCENT: 'var(--action-accent)',
        WARNING: 'var(--warning)',
        ERROR: 'var(--error)',
        ORANGE: 'var(--orange)',
        PURPLE: 'var(--purple)'
    }
}
